<template>
    <div>
      <v-card class="rounded-lg pa-6" elevation="0">  
        <v-toolbar flat>
            <v-toolbar-title>Lista de Habilidades: {{ profileName }}</v-toolbar-title>
        </v-toolbar>
        <v-row no-gutters class="px-4">
            <v-col v-for="item in abilities" :key="item.id" cols="12" sm="6" md="4">
                <v-checkbox
                    v-model="selectedItems"
                    :value="item"
                    :label="item.name"
                    color="#41916b"
                    hide-details
                    dense
                ></v-checkbox>
            </v-col>
        </v-row>
        <br>
        <v-row>
            <v-btn color="#41916b" dark class="rounded-lg" @click="saveAbilities()" :loading="loading" style="margin-right: 10px; margin-left: 10px">{{$t('buttons.save')}}</v-btn>
            <v-btn  class="rounded-lg" @click="$router.push('/perfis')">{{$t('buttons.return')}}</v-btn>
        </v-row>
      </v-card>

      <v-snackbar absolute background-color="white" color="#104a21" v-model="snackbar">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import { getAbilities, saveAbilities } from "@/service/basic-registrations/ProfileService";
import { mapActions } from "vuex";
  export default {
    data() {
      return {
        profileName:"",
        selectedItems: [],
        selectedItemsId: [],
        abilities: [],
        snackbar: false,
        message: "",
        loading: false
      };
    },

    async created() {
        this.profileName = this.$route.query.item.name
        await this.loadAbilities();

        this.$nextTick(() => {
            this.fillAbilities();
        });
    }, 

    methods: {
        ...mapActions([
            "changeSnackBarData", 
        ]),

        loadAbilities(){
            return getAbilities().then((result) => {
                this.abilities = result;
            });
        },

        saveAbilities(){
            this.loading = true;

            let abilities = this.selectedItems.map((item) => item.id)
            let id = this.$route.query.item.id

            const data = {
                abilities: abilities
            }

            saveAbilities(id, data).then((response) => {
                this.loading = false;
                this.changeSnackBarData({
                    status: true,
                    type: 'success', 
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: 'success',
                    titleIcon: 'mdi-check-circle',
                }); 

                setTimeout(() => { 
                    this.$router.push('/perfis')
                    this.closeSnackBar();
                }, 3000);
            }).catch((error) => {
                this.loading = false;
                this.changeSnackBarData({
                    status: true,
                    type: 'erro', 
                    titleMessage: this.$t('messages.something_went_wrong'),
                    bodyMessage: error.error,
                    cardColor: 'red',
                    titleIcon: 'mdi-close-circle',
                });

                setTimeout(() => {
                    this.closeSnackBar();
                }, 3000);
            });
        },
 
        fillAbilities() {
            const abilityIds = this.$route.query.item.abilities.map(
                (item) => parseInt(item.pivot.ability_id)
            );

            // só adiciona os que realmente existem na tabela
            this.selectedItems = this.abilities.filter((a) =>
                abilityIds.includes(a.id)
            );
        },

        closeSnackBar(){
            this.changeSnackBarData({
                status: false,
                type: '', 
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        }

    }
  };
  </script>
  